export const formatABN = (value: string) => {
  const trimmedValue = value.replace(/\s/g, '');
  return trimmedValue.length === 11
    ? trimmedValue.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4')
    : value;
};
